import { IconSizes, IconVariants } from "@/src/easy-icons/types";

const ICON_TO_SVGS_OUTLINED_12 = "ICON_TO_SVGS_OUTLINED_12";

const ICON_TO_SVGS_FILLED_12 = "ICON_TO_SVGS_FILLED_12";

const ICON_TO_SVGS_OUTLINED_16 = "ICON_TO_SVGS_OUTLINED_16";

const ICON_TO_SVGS_FILLED_16 = "ICON_TO_SVGS_FILLED_16";

const ICON_TO_SVGS_OUTLINED_24 = "ICON_TO_SVGS_OUTLINED_24";

const ICON_TO_SVGS_FILLED_24 = "ICON_TO_SVGS_FILLED_24";

const ICON_TO_SVGS_OUTLINED_32 = "ICON_TO_SVGS_OUTLINED_32";

const ICON_TO_SVGS_FILLED_32 = "ICON_TO_SVGS_FILLED_32";

export const ICON_METADATA = [
  { size: IconSizes.Small, path: IconVariants.Outlined, name: ICON_TO_SVGS_OUTLINED_12 },
  { size: IconSizes.Small, path: IconVariants.Full, name: ICON_TO_SVGS_FILLED_12 },
  { size: IconSizes.Medium, path: IconVariants.Outlined, name: ICON_TO_SVGS_OUTLINED_16 },
  { size: IconSizes.Medium, path: IconVariants.Full, name: ICON_TO_SVGS_FILLED_16 },
  { size: IconSizes.Large, path: IconVariants.Outlined, name: ICON_TO_SVGS_OUTLINED_24 },
  { size: IconSizes.Large, path: IconVariants.Full, name: ICON_TO_SVGS_FILLED_24 },
  { size: IconSizes.XLarge, path: IconVariants.Outlined, name: ICON_TO_SVGS_OUTLINED_32 },
  { size: IconSizes.XLarge, path: IconVariants.Full, name: ICON_TO_SVGS_FILLED_32 },
];
